import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "src/utils/api";
import { StatusCodes } from "http-status-codes";
import message from "antd/es/message";
import {
  FETCH_CORPORATE,
  ADD_CORPORATE,
  GET_COMPANYID,
  EDIT_CORPORATE,
} from "../actions/corporateAction";
import {
  fetchCorporateListSuccess,
  fetchCorporateListFailure,
  addCorporateSuccess,
  addCorporateFailure,
  fetchCompanyIdSuccess,
  fetchCompanyIdFailure,
  editEnterprisesSuccess,
  editEnterprisesFailure,
} from "../slices/corporateSlice";
import notification from "antd/es/notification";

export function* fetchCorporateSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK)
      yield put(fetchCorporateListSuccess(result));
    else {
      yield put(fetchCorporateListFailure(result.message));
      notification.error({
        message: "Data Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(fetchCorporateListFailure(error.message));
  }
}

export function* fetchCompanyIdSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK)
      yield put(fetchCompanyIdSuccess(result));
    else {
      yield put(fetchCompanyIdFailure(result.message));
      message.error(result.message);
    }
  } catch (error: any) {
    yield put(fetchCompanyIdFailure(error.message));
  }
}

export function* AddCorporateSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    // if (result.status >= 200 && result.status < 300)
    if (result.status == StatusCodes.OK) {
      yield put(addCorporateSuccess(result.data));
      notification.success({
        message: "Add Corporate success",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    } else {
      yield put(addCorporateFailure(result.message));
      notification.error({
        message: "Add Corporate Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error) {
    yield put(addCorporateFailure(error));
  }
}

export function* EditEnterprisesSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK) {
      yield put(editEnterprisesSuccess(result.data));
      notification.success({
        message: "Update Corporate success",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    } else {
      yield put(editEnterprisesFailure(result.message));
      notification.error({
        message: "Update Corporate Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error) {
    yield put(editEnterprisesFailure(error));
  }
}

export default function* historySaga() {
  yield all([
    takeLatest(FETCH_CORPORATE, fetchCorporateSaga),
    takeLatest(ADD_CORPORATE, AddCorporateSaga),
    takeLatest(GET_COMPANYID, fetchCompanyIdSaga),
    takeLatest(EDIT_CORPORATE, EditEnterprisesSaga),
  ]);
}
